import React, { useState } from "react";

const faqData = {
  owners: [
    {
      q: "What kind of companies does Northstar acquire?",
      a: "Security integration and alarm companies in western North America and Canada with roughly $1–5M in revenue, ten or more years of operating history, and a reputation their market trusts. Commercial and institutional work is our sweet spot, and an installed base with room to grow recurring services is a plus. If you're close to that profile but not exact, call anyway — the conversation costs nothing.",
    },
    {
      q: "How do you value a business like mine?",
      a: "On fundamentals: sustainable earnings, the quality and stickiness of your customer base, contracted recurring revenue, team stability, and local reputation. Recurring monitoring and service contracts are valued on their own merits, separately from project revenue. We'll show you our math line by line — you should never have to guess how a buyer got to a number.",
    },
    {
      q: "What happens to my role after the sale?",
      a: "That's designed around your goals, not ours. Most founders stay 12–24 months to hand over relationships on their terms; some stay longer in leadership, others step back sooner with a planned transition. We'll agree on it in the LOI so there are no surprises.",
    },
    {
      q: "How is the purchase structured and funded?",
      a: "The majority of the price is cash at close, with the balance in structures that align us — such as a seller note, an earnout, or equity in the platform if you want ongoing upside. Northstar is backed by committed institutional capital, so financing is never a condition we hide behind.",
    },
    {
      q: "Will you keep this confidential?",
      a: "Absolutely. Early conversations happen under NDA, and nothing reaches your employees, customers, or competitors until you decide it should. When it's time, we plan the announcement together — your team hears it from you, with us beside you.",
    },
  ],
  teams: [
    {
      q: "Our company was just acquired. What changes for me?",
      a: "Day to day, very little — and what does change should make your job easier. Same brand, same location, same local leadership. What's new is support: better tools, real training budgets, purchasing power, and a back office that takes admin off your plate.",
    },
    {
      q: "Are layoffs part of the plan?",
      a: "No. We acquire service businesses, and in a service business the team is the asset. The industry-wide shortage is technicians, not jobs — our problem is finding more great people, not reducing the ones we have.",
    },
    {
      q: "What growth opportunities come with Northstar?",
      a: "Manufacturer certifications, structured technician training, and a network of sister companies across the platform. As we grow, so do paths into lead tech, service management, and operations leadership roles that a single-branch company could rarely offer.",
    },
    {
      q: "Do we have to switch products or vendors?",
      a: "You keep making the right product decisions for your customers. What you gain is platform pricing and direct manufacturer relationships — the same gear, on better terms, with technical support closer at hand.",
    },
  ],
  customers: [
    {
      q: "Our security provider joined Northstar. What should we expect?",
      a: "Continuity first: the same local team, the same phone number, the same people who know your sites. Behind the scenes, your provider now has deeper resources — so response times, parts availability, and service capacity improve rather than slip.",
    },
    {
      q: "What new capabilities come with Northstar?",
      a: "Live 24/7 remote video monitoring, managed cloud video, and modern access control services — delivered through the local team you already trust. Many customers use the transition to finally consolidate monitoring, service, and installation under one roof.",
    },
    {
      q: "We have sites in multiple cities. Can you cover them?",
      a: "Yes — that's one of the biggest advantages of the platform. Northstar companies work to one standard across western North America and Canada, so multi-site customers get consistent workmanship and a single point of accountability, delivered by local crews in each market.",
    },
  ],
};

const tabs = [
  ["owners", "Business Owners"],
  ["teams", "Employees & Teams"],
  ["customers", "Customers"],
];

const SentinelFAQ = () => {
  const [aud, setAud] = useState("owners");
  return (
    <section className="faq dark" id="faq">
      <div className="wrap">
        <span className="eyebrow">Questions, answered</span>
        <h2 className="display">For owners. For teams. For customers.</h2>
        <div className="tabs" role="tablist" aria-label="FAQ audience">
          {tabs.map(([key, label]) => (
            <button
              key={key}
              className="tab"
              role="tab"
              aria-selected={aud === key}
              id={`t-${key}`}
              aria-controls={`p-${key}`}
              onClick={() => setAud(key)}
            >
              {label}
            </button>
          ))}
        </div>
        {tabs.map(([key]) => (
          <div
            key={key}
            className={`panel ${aud === key ? "active" : ""}`}
            id={`p-${key}`}
            role="tabpanel"
            aria-labelledby={`t-${key}`}
          >
            {faqData[key].map((item, i) => (
              <details className="acc" key={item.q} open={i === 0}>
                <summary>
                  {item.q}
                  <span className="chev">{">"}</span>
                </summary>
                <div className="body">{item.a}</div>
              </details>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};

export default SentinelFAQ;
